import { IContactLink } from "../types";

export const CONTACT_LINK_FALLBACKS: Record<string, string> = {
  consultant: "https://t.me/Maks_1888",
  jurist: "https://t.me/Migrationconsult1",
  ai: "https://t.me/vputionlinehelper_bot?start=welcome",
};

export const buildContactLinksMap = (
  links: IContactLink[] | null | undefined,
): Record<string, string> => {
  const map: Record<string, string> = { ...CONTACT_LINK_FALLBACKS };

  (links || []).forEach((item) => {
    if (!item?.code) return;
    const target = item.track_url || item.telegram_url;
    if (target) {
      map[item.code] = target;
    }
  });

  return map;
};
